export enum DeepLinkQueryParam {
  DEEP_LINK_GUID = 'deepLinkGuid',
  ENABLE_DEEP_LINK = 'enableDeepLink'
}
